import { IViewSubcategoryContext } from './viewSubcategoryContext';

export enum ViewSubcategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	REFETCH_REST_PROPS_DATA = 'REFETCH_REST_PROPS_DATA',
	SET_SUBCATEGORY_FULL_INFO = 'SET_SUBCATEGORY_FULL_INFO',
	SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS = 'SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS',
	SET_RESTAURANT_PROPS = 'SET_RESTAURANT_PROPS',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: ViewSubcategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IViewSubcategoryContext['needRefetchData'];
	};
}

interface IRefetchRestPropsData {
	type: ViewSubcategoryActionTypes.REFETCH_REST_PROPS_DATA;
	payload: {
		needRefetchRestPropsData: IViewSubcategoryContext['needRefetchRestPropsData'];
	};
}

interface ISetSubcategoryFullInfo {
	type: ViewSubcategoryActionTypes.SET_SUBCATEGORY_FULL_INFO;
	payload: {
		subcategoryFullInfo: IViewSubcategoryContext['subcategoryFullInfo'];
		accessibleRestaurants: IViewSubcategoryContext['accessibleRestaurants'];
	};
}

interface ISetRestaurantIdForRestaurantProps {
	type: ViewSubcategoryActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS;
	payload: {
		restaurantIdForRestaurantProps: IViewSubcategoryContext['restaurantIdForRestaurantProps'];
		restaurantProps: IViewSubcategoryContext['restaurantProps'];
	};
}

interface ISetRestaurantProps {
	type: ViewSubcategoryActionTypes.SET_RESTAURANT_PROPS;
	payload: {
		restaurantProps: IViewSubcategoryContext['restaurantProps'];
	};
}

interface ISetTranslationTab {
	type: ViewSubcategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IViewSubcategoryContext['selectedTranslationTab'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ViewSubcategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IViewSubcategoryContext['typeOfModalWindow'];
	};
}

export type TViewSubcategoryAction =
	| IRefetchData
	| IRefetchRestPropsData
	| ISetSubcategoryFullInfo
	| ISetRestaurantIdForRestaurantProps
	| ISetRestaurantProps
	| ISetTranslationTab
	| IChangeTypeOfModalWindow;
